// extracted by mini-css-extract-plugin
export default {"shake":"randomcocktail_shake__4brz4","different":"randomcocktail_different__SqLAu"};